import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, withStyles, Theme } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import './style.scss';
import { SEARCH_BANNER_API } from "../../apiContants";
import AlertNotice from "../../components/common/alertCommon";

const BootstrapInput = withStyles((theme) =>
  createStyles({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  })
)(InputBase);

const BannerDetail = (props) => {
  const { getSelectedData, setOpen } = props;
  const useForceUpdate = () => useState()[1];
  const listOrder = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
  const [order, setOrder] = React.useState("");
  const fileInput = useRef(null);
  const forceUpdate = useForceUpdate();
  const [reg, regSet] = useState(Array);
  const [value, setValues] = React.useState({
    subject: "",
    content: "",
    order: "",
  });
  const [openAlert, setOpenAlert] = useState(false);
  const [alertContent, setAlertContent] = useState(null);
  const handleChangeForm = (subject) => (event) => {
    setValues({ ...value, [subject]: event.target.value });
  };
  const handleChangeFormContent = (content) => (event) => {
    setValues({ ...value, [content]: event.target.value });
  };
  const handleChangeFormOrder = (order) => (event) => {
    setValues({ ...value, [order]: event.target.value });
    setOrder(event.target.value);
  };

  function onSubmit(e) {
    e.preventDefault();
    const data = new FormData(fileInput.current.files);
  }
  const onSubmited = async () => {
    const data = new FormData();
    data.append("upload_file", fileInput.current.files[0]);
    data.append("name", value.subject);
    data.append("link", value.content);
    data.append("order", value.order);

    const uploadPass = await axios
      .post(SEARCH_BANNER_API, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setOpenAlert(true);
        setAlertContent("Add Banner Success!");
        setOpen(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <form autoComplete="off" noValidate {...props}>
      <div className="Notice-content">
        <Grid container spacing={3}>
          <Grid item lg={4} md={6} xs={12}>
            <Card {...props}>
              <CardContent>
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    height: 150,
                  }}
                >
                  <div className="App">
                    <form onSubmit={onSubmit}>
                      <input
                        id="file"
                        type="file"
                        ref={fileInput}
                        onChange={forceUpdate}
                        multiple
                      />
                    </form>
                  </div>
                </Box>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
          <Grid item lg={8} md={6} xs={12}>
            <Card>
              <CardHeader
                subheader="The information can be edited"
                title="Banner"
              />
              <Divider />
              <CardContent>
                <TextField
                  fullWidth
                  label="Banner Name"
                  margin="normal"
                  name="password"
                  onChange={handleChangeForm("subject")}
                  value={value.password}
                  variant="outlined"
                />
                <TextField
                  fullWidth
                  label="Banner Link"
                  margin="normal"
                  name="password"
                  onChange={handleChangeFormContent("content")}
                  value={value.password}
                  variant="outlined"
                />
                <FormControl>
                  <InputLabel htmlFor="demo-customized-select-native">
                    Order
                  </InputLabel>
                  <NativeSelect
                    id="demo-customized-select-native"
                    value={order}
                    onChange={handleChangeFormOrder("order")}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="" />
                    {listOrder.map((orderr, idx) => (
                      <option value={orderr}>{orderr}</option>
                    ))}
                    {/* <option value={20}>Twenty</option>
                <option value={30}>Thirty</option> */}
                  </NativeSelect>
                </FormControl>
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  p: 2,
                }}
              >
                <Button
                  className="cancel_button"
                  color="primary"
                  variant="contained"
                  onClick={() => setOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => onSubmited()}
                  color="primary"
                  variant="contained"
                >
                  Save details
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
        <AlertNotice
          openAlert={openAlert}
          setOpenAlert={setOpenAlert}
          alertContent={alertContent}
        ></AlertNotice>
      </div>
    </form>
  );
};

export default BannerDetail;
